import React from 'react';
import Sidebar from '../../components/Sidebar/Sidebar';
import Metrics from '../../components/Metrics/Metrics';
import NotificationBell from '../../components/NotificationBell/NotificationBell';
import SystemAdminBadge from '../../components/SystemAdminBadge/SystemAdminBadge';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
import { useCurrentUserPermissions } from '../../hooks/useCurrentUserPermissions';
import styles from './MetricsPage.module.scss';

const MetricsPage: React.FC = () => {
  const { isSystemAdmin } = useCurrentUserPermissions();

  return (
    <div className={styles.pageLayout}>
      <Sidebar />
      <div className={styles.pageContent}>
        <div className={styles.pageToolbar}>
          <LanguageSwitcher />
          {isSystemAdmin ? <SystemAdminBadge /> : <NotificationBell />}
        </div>
        <Metrics />
      </div>
    </div>
  );
};

export default MetricsPage;
